import {State} from "../type";

import {ReducerMovieState} from "./reducer";

export function selectReducerMovieState(state: State): ReducerMovieState {
    return state.reducerMovieDetail;
}

